module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHBJREFUeNpiYBhsgBFKCwBxApQmBXwA4gVQmsEAiN8D8X8y8XuoGQz7KTAEhs8zQhkUAyZqBfaoQcQZdIAK5hygWoJEziIBQKwAxPVotk0A4o84XPIAiDfAsgg6QLYpgRL/ouQfSsB5MkoB6gGAAAMAtMdCtzUepecAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CalloutIcon_Messages.png
// module id = lHii
// module chunks = 1